import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Brand } from 'src/typings';

@Component({
  selector: 'app-catalogue-brand-selector',
  templateUrl: './catalogue-brand-selector.component.html',
  styleUrls: ['./catalogue-brand-selector.component.scss']
})
export class CatalogueBrandSelectorComponent implements OnDestroy {
  @Input() loading: boolean | undefined;

  constructor() {
    this.controlSubscription = this.searchControl.valueChanges.subscribe((value) => {
      this.filter(value);
    });
  }

  ngOnDestroy(): void {
    this.controlSubscription.unsubscribe();
  }

  searchControl: FormControl = new FormControl();

  controlSubscription: Subscription;

  @Input() set brands(payload: Brand[]) {
    this._allBrands = payload;
    this._brands = payload;
  }

  private _brands: Brand[] = [];

  get brands() {
    return this._brands;
  }

  private _allBrands: Brand[] = [];

  @Input() set selectedBrands(payload: Brand[]) {
    this._selectedBrands = payload;
  }

  private _selectedBrands: Brand[] = [];

  get selectedBrands() {
    return this._selectedBrands;
  }

  @Output() selectedBrandsChanges: EventEmitter<Brand[]> = new EventEmitter();

  clear() {
    this.searchControl.setValue('');
  }

  filter(value: string) {
    this._brands = this._allBrands.filter((brand) => {
      return brand.description.toUpperCase().includes(value.toUpperCase());
    });
  }

  toggle(brand: Brand) {
    const findIndex = this.selectedBrands.findIndex((selected_brand) => {
      return brand.id === selected_brand.id;
    });
    if (findIndex == -1) {
      this.selectedBrands.push(brand);
    } else {
      this.selectedBrands.splice(findIndex, 1);
    }
    this.selectedBrandsChanges.emit(this.selectedBrands);
  }

  isSelected(brand: Brand) {
    const find = this.selectedBrands.find((selectedBrand) => selectedBrand.id === brand.id);
    if (find) return true;
    return false;
  }
}
